export default {
      id: "drag-handle-usage",
      viewBox: "0 0 10 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#drag-handle",
      toString: function () {
        return this.url;
      }
    }